import React from 'react';
import * as S from './SoldoutPriceInfo.styles';

const PriceInfoSoldOut = () => {
  return (
    <S.PriceSoldOutWrapper>
      <S.PriceSoldOutInnerWrapper>
        <S.SoldOutMainText>Sold Out</S.SoldOutMainText>
        <S.MissedText>You just missed it</S.MissedText>
        <S.PropertyBookedText>This property is fully booked for selected dates</S.PropertyBookedText>
      </S.PriceSoldOutInnerWrapper>
    </S.PriceSoldOutWrapper>
  );
};

export default PriceInfoSoldOut;
